import React from "react";
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";
import { Caption1 } from "@activecollab/components";
import classNames from "classnames";
import PropTypes from "prop-types";
import { FormatLocalDate } from "~/components/Formatters";
import UserLink from "~/components/UserLink/UserLink";

export const Metadata = ({
  projectName,
  projectUrlPath,
  taskNumber,
  createdById,
  className,
  createdOn,
  createdByEmail,
  createdByName,
}) => {
  const path = projectUrlPath[0] !== "/" ? "/" + projectUrlPath : projectUrlPath;
  const { t } = useTranslation();
  return (
    <div className={classNames("tw-leading-4", className)}>
      <Caption1
        color="secondary"
        className="tw-inline-block tw-pr-3 tw-mr-3 tw-border-solid tw-border-0 tw-border-r tw-border-border-primary"
      >
        <div className="tw-flex tw-items-center">
          <Link
            to={path}
            className="tw-no-underline tw-text-theme-700 hover:tw-text-secondary tw-truncate tw-max-w-[200px]"
          >
            {projectName}
          </Link>
        </div>
      </Caption1>
      <Caption1
        color="secondary"
        className="tw-inline tw-pr-3 tw-mr-3 tw-border-solid tw-border-0 tw-border-r tw-border-border-primary"
      >
        {`${t("Task")} #${taskNumber}`}
      </Caption1>
      <Caption1
        color="secondary"
        className="tw-inline"
      >
        <span>{t("Created by")}</span>{" "}
        <UserLink
          id={createdById}
          hideAvatar
          renderAs={Caption1}
          nameProps={{ color: "secondary" }}
          name={createdByName}
          email={createdByEmail}
          context="task - created-by"
        />{" "}
        {t("on")}{" "}
        <FormatLocalDate
          value={createdOn}
          long
        />
      </Caption1>
    </div>
  );
};

Metadata.propTypes = {
  projectName: PropTypes.string.isRequired,
  projectUrlPath: PropTypes.string.isRequired,
  taskNumber: PropTypes.number.isRequired,
  createdById: PropTypes.number,
  createdOn: PropTypes.number,
  className: PropTypes.string,
  createdByName: PropTypes.string,
  createdByEmail: PropTypes.string,
};

Metadata.displayName = "Metadata";
